module.exports = __webpack_public_path__ + "static/media/20ECE31.5a237d52.jpg";